import * as React from 'react';
import { Spinner } from '@fluentui/react-components';
import loadable from '@loadable/component';
import Cookies from 'js-cookie';
import { Redirect, Route, Switch } from 'react-router-dom';
import { usePixelTracking } from '../../modules/telemetry/tags';
import { useFeatureFlagEnabled } from '../../store';

const Loading = <Spinner size="large" />;
const Signup = loadable(() => import(/* webpackChunkName: "signup" */ './Signup'), { fallback: Loading });

const Referral = loadable(() => import(/* webpackChunkName: "signup" */ './Referral'), { fallback: Loading });
const Register = loadable(() => import(/* webpackChunkName: "signup" */ './Register'), { fallback: Loading });
const Apply = loadable(() => import(/* webpackChunkName: "apply" */ './Apply'), {
  fallback: Loading,
});
const Submitted = loadable(() => import(/* webpackChunkName: "submitted" */ './Submitted'), { fallback: Loading });

// remove after Pilot is over
export const isGatedExperience = (flag_on: boolean) => {
  if (flag_on) {
    const gated_param = new URLSearchParams(window.location.search).get('gated-experience');
    if (gated_param) {
      Cookies.set('gated-experience', gated_param, { expires: 14 }); // Set cookie for 14 days
    }
    return !!(gated_param || Cookies.get('gated-experience'));
  }
  return flag_on;
};

export default function ApplyFlow() {
  usePixelTracking();
  const gated_application = useFeatureFlagEnabled('gated_application');
  const gated_experience = isGatedExperience(gated_application);

  return (
    <Switch>
      <Route exact path="/signup">
        <Signup />
      </Route>
      {gated_experience && (
        <>
          <Route exact path="/referral">
            <Referral />
          </Route>
          <Route exact path="/register">
            <Register />
          </Route>
        </>
      )}
      <Route exact path="/apply">
        <Apply />
      </Route>
      <Route exact path="/apply/submitted">
        <Submitted />
      </Route>
      <Route>
        <Redirect to="/apply" />
      </Route>
    </Switch>
  );
}
